

















































import Vue from 'vue'
import { Configuration, ConferenceInfoDetail, UploadedFile, DoctorInfoRestControllerApi } from '@/types/api-docs'
import FileForm from '@/components/FileForm.vue'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import Initializer from '@/utils/initializer'
import Utils from '@/utils/utils'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  conferenceInfo?: ConferenceInfoDetail
  conferenceInfosId: number
  conferenceInfoContent: string
  uploadedFiles?: { [p: string]: UploadedFile }
  isFormValid: boolean
}

const api = new DoctorInfoRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export default Vue.extend({
  components: {
    FileForm,
  },
  data(): DataType {
    return {
      pageName: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学会', '組織'), this.$route.meta.title),
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: Utils.replaceOrganization(Utils.switchOrganization(this.$store.getters.organization, '学会', '組織'), this.$route.meta.title),
          disabled: true,
        },
      ],
      conferenceInfo: Initializer.initConferenceInfoDetail(this.$store.getters.conferencesId),
      conferenceInfosId: Number(this.$route.params.id),
      conferenceInfoContent: '',
      uploadedFiles: undefined,
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchConferenceInfoDetail()
    await this.fetchConferenceInfoFiles()
  },
  computed: {},
  methods: {
    async fetchConferenceInfoDetail() {
      const { data } = await api.fetchMemberConferenceInfoDetail(this.conferenceInfosId)
      this.conferenceInfo = data
      this.conferenceInfoContent = Utils.sanitizeText(this.conferenceInfo.content).replaceAll(/\n/g, '<br>')
    },
    async fetchConferenceInfoFiles() {
      const { data } = await api.fetchMemberConferenceInfoFiles(this.conferenceInfosId)
      this.uploadedFiles = data
    },
    formatDate(date: string, format: string) {
      return Utils.formatStringDate(date, format)
    },
    existFile() {
      if (!this.uploadedFiles) {
        return false
      }
      for (let key of Object.keys(this.uploadedFiles)) {
        if (this.uploadedFiles[key].url) {
          return true
        }
      }
      return false
    },
  },
})
